/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Why_Listening_Testimonials_DescriptionInputs */

const en_why_listening_testimonials_description = /** @type {(inputs: Why_Listening_Testimonials_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Students and researchers on what changed when they moved their reading to Listening.`)
};

const es_why_listening_testimonials_description = /** @type {(inputs: Why_Listening_Testimonials_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estudiantes e investigadores cuentan qué cambió al pasar su lectura a Listening.`)
};

/**
* | output |
* | --- |
* | "Students and researchers on what changed when they moved their reading to Listening." |
*
* @param {Why_Listening_Testimonials_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const why_listening_testimonials_description = /** @type {((inputs?: Why_Listening_Testimonials_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Why_Listening_Testimonials_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_why_listening_testimonials_description(inputs)
	return en_why_listening_testimonials_description(inputs)
});